import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmModal from "components/ConfirmModal";
import useToast from "hooks/useToast";
import { ModalProps } from "components/Modal";
import { IconCopy } from "@tabler/icons-react";
import MakeContactModal from "./MakeContactModal";
import { SOFTWARE_EMAIL } from "utils";

interface IProps extends ModalProps {
  sampleBuildingStatus: string | null;
  onAddSampleBuilding: () => Promise<void>;
  maxBuildingNo: number;
}

const MaxBuildingCountAlert = (props: IProps) => {
  const { t } = useTranslation();
  const toast = useToast();
  const [showContactView, setShowContactView] = React.useState<boolean>(false);

  const createDemoBuilding = async () => {
    await props.onAddSampleBuilding();
    toast(t("onboarding.addDemoBuildingSuccess"), "success");
    props.close();
  };

  const openContactModal = () => setShowContactView(true);

  const copyEmail = async () => {
    await navigator.clipboard.writeText(SOFTWARE_EMAIL);
    props.close();
  };

  if (showContactView) {
    return (
      <MakeContactModal
        open={showContactView}
        close={() => setShowContactView(false)}
      />
    );
  }

  const noBuilingAllowed = props.maxBuildingNo === 0;

  return (
    <ConfirmModal
      open={props.open}
      close={props.close}
      type="info"
      title={
        noBuilingAllowed
          ? t("dashboard.max_building_heading_zero")
          : t("dashboard.max_building_heading")
      }
      containerClassName="sm:my-8 sm:max-w-sm sm:w-full md:max-w-xl"
      descriptionMesage={
        <div
          dangerouslySetInnerHTML={{
            __html: noBuilingAllowed
              ? t("dashboard.max_building_message_zero")
              : t("dashboard.max_building_message", {
                  email: SOFTWARE_EMAIL,
                }),
          }}
        ></div>
      }
      confirmButtonTitle={
        noBuilingAllowed
          ? t("dashboard.makeContact")
          : t("dashboard.copyEmailAddress")
      }
      confirmButtonIcon={
        noBuilingAllowed ? undefined : <IconCopy className="ml-1" />
      }
      secondaryButtonTitle={t("onboarding.addDemoBuilding")}
      secondaryButtonAction={createDemoBuilding}
      secondaryButtonLoading={props.sampleBuildingStatus === "in_progress"}
      onConfirm={() => (noBuilingAllowed ? openContactModal() : copyEmail())}
      hideCancel
    ></ConfirmModal>
  );
};

export default MaxBuildingCountAlert;
